module.exports = __webpack_public_path__ + "static/img/ddemr-details.65c9390.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ddemr-details.png
// module id = iuAi
// module chunks = 0